import { format } from 'date-fns'
import patientUtils from '@/plugins/lib@patient/utils/patient.utils'

export default {
	data() {
		return {
			columns: [
				{
					label: this.$t('Meno a priezvisko'),
					field: (request) => request,
					sortable: false,
					formatFn: (request) => patientUtils.getFullName({ first_name: request.first_name, last_name: request.last_name })
				},
				{
					label: this.$t('Rodné číslo'),
					field: 'personal_id',
					sortable: false
				},
				{
					label: this.$t('Dátum narodenia'),
					field: 'date_of_birth',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), 'dd.MM.yyyy') : null
					}
				},
				// {
				// 	label: this.$t('Číslo objednávky'),
				// 	field: 'id',
				// 	sortable: false,
				// },
				{
					label: this.$t('Číslo žiadanky'),
					field: 'request_id',
					sortable: false
				},
				{
					label: this.$t('Dátum žiadanky'),
					field: 'creation_date',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), this.$t("dd.MM.yyyy 'o' HH:mm")) : null
					}
				},
				{
					label: this.$t('Dátum výsledku'),
					field: 'last_result_date',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), this.$t("dd.MM.yyyy 'o' HH:mm")) : null
					}
				},
				{
					label: this.$t('Možnosti'),
					field: 'actions',
					sortable: false
				}
			]
		}
	},

	computed: {
		queryOcmsPagination() {
			const pagination = {
				page: this.pagination.current_page,
				per_page: this.pagination.per_page == 'all' ? this.pagination.total : this.pagination.per_page
			}
			return new URLSearchParams(pagination).toString()
		},
	},

	methods: {
		queryFilters(returnObject = false) {
			const filters: any = {
				has_result: true
			}

			if (this.filters.state == 'UNREAD') filters.readed = false

			if (this.filters.search?.length) filters.search = this.filters.search

			if (this.filters.date_sent) {
				filters.created_from = this.filters.date_sent
				filters.created_to = this.filters.date_sent
			}

			if (this.filters.updated_from && this.filters.updated_to) {
				filters.last_result_from = this.filters.updated_from
				filters.last_result_to = this.filters.updated_to

				// TODO
				// this.filters.last_result = {
				// 	start: this.filters.updated_from,
				// 	end: this.filters.updated_to
				// }
			} else if (this.filters.last_result?.start && this.filters.last_result?.end) {
				filters.last_result_from = this.filters.last_result.start
				filters.last_result_to = this.filters.last_result.end
			}

			if (returnObject) return filters
			return new URLSearchParams(filters).toString()
		},

		updateLabels() {
			this.columns = [
				{
					label: this.$t('Meno a priezvisko'),
					field: (result) => `${result.first_name} ${result.last_name}`,
					sortable: false,
				},
				{
					label: this.$t('Rodné číslo'),
					field: 'personal_id',
					sortable: false,
				},
				{
					label: this.$t('Dátum narodenia'),
					field: 'date_of_birth',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), "dd.MM.yyyy") : null
					}
				},
				{
					label: this.$t('Číslo žiadanky'),
					field: 'request_id',
					sortable: false,
				},
				{
					label: this.$t('Dátum žiadanky'),
					field: 'creation_date',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), this.$t("dd.MM.yyyy 'o' HH:mm")) : null
					}
				},
				{
					label: this.$t('Dátum výsledku'),
					field: 'last_result_date',
					sortable: false,
					formatFn: (value) => {
						return value ? format(new Date(value), this.$t("dd.MM.yyyy 'o' HH:mm")) : null
					}
				},
				{
					label: this.$t('Možnosti'),
					field: 'actions',
					sortable: false,
				}
			]
		}
	},

	watch: {
		'$i18n.locale'() {
			this.updateLabels()
		}
	}
}
